<template>
  <div>
    <label :for=label>{{ labelFormatted }}</label>
    <input type="text"
           id="streetNumber"
           :value="value"
           :required="required"
           @input="event => $emit('updateStreetNumber', event.target.value)"
    />
  </div>
</template>

<script>
import {computed, defineComponent, ref, watch, onMounted} from "vue";
import autocomplete from 'autocompleter';
import AutocompleteAPI from '@/api/resources/autocomplete';

const selectedValue = ref('')
export default defineComponent({
  name: 'textInputFieldAutocomplete',
  emits: ['updateStreetNumber'],
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    id: {
      type: String,
      required: true,
      default: ""
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    zipcode: {
      type: String,
    }
  },
  setup(props, { emit }) {

    onMounted(() => {
      const input = document.getElementById('streetNumber');

      autocomplete({
        input: input,
        className: 'autocomplete',
        debounceWaitMs: 100,
        minLength: 3,
        fetch: async function (address, update) {
          address = address.toLowerCase();
          input.dataset.resultType = '';
          let addresses = await AutocompleteAPI.address(address, props.zipcode);
          input.dataset.resultType = addresses['type'];
          update(addresses['results']);
        },
        render: function(item) {
            let div = document.createElement('div');
            div.textContent = item;
            div.className = 'listItem'
            return div;
        },
        onSelect: function (item) {
          input.value = item;
          selectedValue.value = item;
          if (input.dataset.resultType === 'street') {
            input.click()
          }
        },
        click: function (e) {
          if (input.dataset.resultType === 'street') {
            e.fetch();
          }
        }
      });
    });

    const labelFormatted = computed(()=> {
        return props.label;
    })

    watch(selectedValue, async (newVal, oldVal) => {
      let streetNumber = newVal ? newVal : oldVal
      emit('updateStreetNumber', streetNumber)
    })

    return { labelFormatted }
  }
})
</script>

<style scoped lang="scss">
  div {
    display: flex;
    flex-direction: column;
  }

  label {
    margin-bottom: 5px;
  }
</style>
